<template>
    <div class="layout-right flex flex-v">
        <div class="layout-right-top">
            <right-top bread="收银中心-快速收银"></right-top>
        </div>
        <div class="layout-right-body flex-1 flex flex-v">
            <!--搜索会员-->
            <div class="item-box item-tools">
                <el-button type="primary" @click="addUserShow = true">添加会员</el-button>
                <el-button @click="storeUserSearched">查找会员</el-button>
                <el-button style="width: 98px;" @click="tempOrderShow = true">取单<span class="" v-if="tmpOrderNUm > 0">({{tmpOrderNUm}})</span></el-button>
                <el-button @click="cashMoreOrderShow = true">多单结账</el-button>
                <div class="order-no-box">
                    <span class="label">单号</span>
                    <el-input v-model="orderNo" placeholder="请输入单号" class="input" style="width: 180px"></el-input>
                </div>
                <div class="order-no-box">
                    <span class="label">补单</span>
                    <el-date-picker v-model="orderDatetime" type="date" value-format="yyyy-MM-dd"
                            style="width: 180px" placeholder="请选择日期" :clearable="false" />
                </div>
            </div>

            <!--选项目-->
            <div class="item-content flex-1 flex">
                <div class="pro-select-box flex flex-v">
                    <pro-select @selected="selectProEvent"></pro-select>
                </div>
                <div class="pro-content-box flex-1 flex flex-v">
                    <cash-content-box :order-list="orderList" v-model="orderIndex"
                                      @addOrder="addOrder" @removeOrder="removeOrder" @deleteProduct="deleteProduct"
                                      @updateProductList="flushOrderData"
                    />
                </div>
            </div>

            <!--结算-->
            <div class="layout-right-bottom">
                <pay-total ref="payTotal" :order-list="orderList" :order-index="orderIndex" :order-option="orderOption"
                           @settleOver="settleOver" @saveTmpOrder="saveTmpOrderDone" @clearProduct="closeProduct"
                           @settle="settle"
                />
            </div>
        </div>

        <!--添加顾客-->
        <store-user-edit v-model="addUserShow" />
        <!--取单-->
        <temp-order v-model="tempOrderShow" @selected="selectedTempOrder" :list-data="orderList" />
        <!--联合结算-->
        <cash-select-order :order-list="orderList" v-model="cashMoreOrderShow" @selected="settle" />
        <!--结算-->
        <cash-total-box v-model="totalBoxState" :order-list="settleData" @settleOver="settleOver" />
        <!--搜索会员-->
        <SearchUserBox v-model="searchUserState" />
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import SearchUser from "@/model/Cash/SearchUser";
    import ProSelect from "@/model/Cash/ProSelect";
    import PayTotal from "@/model/Cash/PayTotal";
    import obj from "@/js/obj";
    import StoreUserEdit from "@/model/StoreUser/StoreUserEdit";
    import TempOrder from "@/model/Cash/TempOrder";
    import CashContentBox from "@/model/Cash/CashContentBox";
    import CashSelectOrder from "@/model/Cash/CashSelectOrder";
    import CashTotalBox from "@/model/Cash/CashTotalBox";
    import SearchUserBox from "@/model/StoreUser/SearchUserBox";
    export default {
        name: "Index",
        components: {
            SearchUserBox,
            CashTotalBox,
            CashSelectOrder,
            CashContentBox,
            TempOrder, StoreUserEdit, PayTotal, ProSelect, SearchUser, RightTop},
        data: () => {
            return {
                orderNo: "",
                orderDatetime: "",
                orderIdx: 1,        //订单序列号
                orderIndex: 0,      //选项卡索引
                orderList: [],      //订单列表
                orderOption: {},    //订单配置

                //结算
                totalBoxState: false,
                settleData: [],

                //挂单
                tempOrderShow: false,
                tmpOrderNUm: 0,

                // orderData: {
                //     tmp_id: "",     //挂单的ID
                //     order_date: "",
                //     order_no: "",   //单号
                //     pro_list: [],   //收银项目列表
                //     userInfo: {},       //会员信息
                // },
                addUserShow: false, //添加会员框显示状态
                cashMoreOrderShow: false,   //多单收银选择框显示状态

                //搜索会员
                searchUserState: false,
            };
        },
        mounted: function () {
            this.$store.commit("setMenuId", "2-1");
            this.syncOrderData();
            this.addOrder();
            // this.getTempOrderNum();
            this.getOrderOption();
        },
        methods: {
            //同步结算信息
            syncOrderData: function () {
                if(this.orderIndex < 0)
                    this.orderIndex = 0;

                let orderData = this.orderList[this.orderIndex];
                if(!obj.isEmpty(orderData)){
                    this.orderNo = orderData.order_no;
                    this.orderDatetime = orderData.order_date;
                }else{
                    this.orderNo = "";
                    this.orderDatetime = "";
                }
            },
            //搜索会员结果
            storeUserSearched: function () {
                this.searchUserState = true;
            },
            //会员充值事件
            payMoney: function (userInfo) {

            },
            //清除项目
            closeProduct: function () {
                this.orderList[this.orderIndex].pro_list = [];
            },

            //---------------------tmp-order----------------------//

            //获取挂单数量
            getTempOrderNum: function () {
                obj.postData("tmp_order/get_count_num", {}, res => {
                    if(res.errcode === 0)
                        this.tmpOrderNUm = res.data;
                });
            },
            //取单结果
            selectedTempOrder: function (orderList) {
                if(orderList && orderList.length > 0){
                    orderList.forEach(item => {
                        this.orderList.push({
                            tmp_id: item.tmp_id,
                            order_date: "", //item.create_datetime,
                            order_index: this.buildOrderIndex(),
                            order_no: item.order_no,
                            pro_list: item.pro_data,
                        });
                    });
                }
            },
            //挂单成功
            saveTmpOrderDone: function () {
                this.removeOrder(this.orderIndex);
                // this.getTempOrderNum();
            },

            //-----------------cash-content-box------------------//

            //删除单个项目
            deleteProduct: function (i) {
                this.orderList[this.orderIndex].pro_list.splice(i, 1);
            },
            //新增订单
            addOrder: function () {
                this.orderList.push({
                    tmp_id: "",     //挂单的ID
                    order_date: "",
                    order_index: this.buildOrderIndex(),
                    order_no: "",   //单号
                    pro_list: [],   //收银项目列表
                });
                this.orderIndex = this.orderList.length - 1;
            },
            //删除订单
            removeOrder: function (index) {
                // if(this.orderList.length <= 1)
                //     return false;

                this.orderList.splice(index, 1);
                if(this.orderIndex > this.orderList.length - 1)
                    this.orderIndex = this.orderList.length - 1;
            },

            //-----------------select-product-----------------//

            //选择项目、产品事件
            selectProEvent: function (proData) {
                let item = {};
                if(proData.proType === "project"){
                    item = {
                        pro_type: 1,                            //1项目，2商品
                        pro_id: proData.proData.pro_id,
                        pro_name: proData.proData.pro_name,
                        c_name: proData.proData.c_name,
                        cid: proData.proData.cid,
                        price: proData.proData.price,
                        num: 1,
                        is_delete: 1,
                        discount: "无",
                        discount_data: {},
                    };
                    this.totalProPrice(item, this.orderIndex);
                }else if(proData.proType === "card"){
                    item = {
                        pro_type: 5,                            //次卡
                        pro_id: proData.proData.pro_id,
                        pro_name: proData.proData.pro_name,
                        price: proData.proData.price,
                        num: 1,
                        is_delete: 1,
                        discount: "无",
                        discount_data: {},
                    };
                    this.totalProPrice(item, this.orderIndex);
                }else if(proData.proType === "goods"){
                    item = {
                        pro_type: 2,
                        pro_id: proData.proData.pro_id,
                        pro_name: proData.proData.pro_name,
                        price: proData.proData.price,
                        num: 1,
                        is_delete: 1,
                        discount: "无",
                        discount_data: {},
                    };
                    this.totalProPrice(item, this.orderIndex);
                }

                //组合订单数据
                let order = {};
                if(!obj.isEmpty(this.orderList[this.orderIndex])) {
                    order = this.orderList[this.orderIndex];
                    order.pro_list.push(item);
                }else{
                    order = {
                        order_date: this.orderDatetime,
                        order_no: this.orderNo,
                        pro_list: [item],
                    };
                }
                this.orderList.splice(this.orderIndex, 1, order);
            },

            //--------------------pay-total----------------------//

            //结账
            settle: function (settleData) {
                //检查订单号
                for (let i = 0; i < settleData.length; i++){
                    let item = settleData[i];
                    if(this.orderOption.requiredOrderNo && obj.isEmpty(item.order_no)) {
                        obj.message.error("请输入单号");
                        return false;
                    }
                }

                this.settleData = settleData;
                this.totalBoxState = true;
            },
            //结账完成
            settleOver: function (idArr) {
                if(!obj.isEmpty(idArr)){
                    idArr.sort(function (a, b) {
                        return b-a;
                    });
                    idArr.forEach( v => {
                        //刷新挂单数量
                        // if(this.orderList[v] && !obj.isEmpty(this.orderList[v].tmp_id))
                            // this.getTempOrderNum();
                        //移除已结算的选项卡
                        this.removeOrder(v);
                    });
                }
            },

            //--------------------通用-------------------//
            //计算项目价格
            totalProPrice: function (item, orderIndex) {
                if(obj.isNull(orderIndex))
                    orderIndex = this.orderIndex;

                //计算折后价
                if (item.discount_data.mode == 1) {
                    item.total_price = item.price * item.num * item.discount_data.data / 10;
                } else if(item.discount_data.mode == 2) {
                    item.total_price = item.discount_data.data * item.num;
                }else{
                    item.total_price = item.price * item.num;
                }
                item.total_price = item.total_price.toFixed(2);
                this.flushOrderData(null, orderIndex);
            },
            //更新orderData
            flushOrderData: function (proList, orderIndex) {
                if(obj.isNull(orderIndex))
                    orderIndex = this.orderIndex;
                let data = {...this.orderList[orderIndex]};

                if(proList)
                    data.pro_list = proList;
                this.orderList.splice(orderIndex, 1, data);
            },
            //获取订单配置
            getOrderOption: function () {
                obj.postData("store_option/get_order_option", {}, res => {
                    if(res.errcode === 0) {
                        if(!obj.isEmpty(res.data)) {
                            this.orderOption = res.data;
                        }
                    }else
                        obj.message.error(res.errdesc);
                });
            },
            //构建订单序号
            buildOrderIndex: function () {
                let no = this.orderIdx;
                this.orderIdx++;
                return no;
            },
        },
        watch: {
            //订单号改变
            orderNo: function (newNo) {
                if(!obj.isEmpty(this.orderList[this.orderIndex]))
                    this.orderList[this.orderIndex].order_no = newNo;
            },

            //订单日期改变
            orderDatetime: function (val) {
                if(!obj.isEmpty(this.orderList[this.orderIndex]))
                    this.orderList[this.orderIndex].order_date = val;
            },

            //订单改变
            orderIndex: function () {
                this.syncOrderData();
            },
            orderList: function () {
                this.syncOrderData();

                if(obj.isEmpty(this.orderList))
                    this.addOrder();
            },

            //挂单显示
            tempOrderShow: function () {
                // this.getTempOrderNum();
            },
        }
    }
</script>

<style scoped>
    .layout-right{
        display: flex;
        flex-flow: column nowrap;
    }
    .order-no-box{
        float: right;
        width: 240px;
        text-align: right;
    }
    .order-no-box .order-date{
        width: 100px;
        margin-right: 10px;
        padding: 0 0;
    }
    .order-no-box .input{
        display: inline-block;
        width: 180px;
    }
    .order-no-box .label{
        display: inline-block;
        margin-right: 10px;
    }
    .item-info{
        padding: 10px 16px 10px;
    }
    .item-content{

    }
    .pro-select-box{
        width: 370px;
    }
    .pro-content-box{
        margin-left: 16px;
    }
    .item-tools{
        padding: 16px;
    }
    .item-tools .el-button+.el-button{
        margin-left: 10px;
    }

</style>

<style>
    .order-no-box .order-date input{
        padding: 0 10px;
    }
</style>
